"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldImage = exports.ModelMutatorImage = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var collection_field_1 = require("../collection.field");
var ModelMutatorImage = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorImage, _super);
    function ModelMutatorImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorImage.prototype.add = function (captureId) {
        var stateValue = this.field.stateValue || [];
        // Don't add existing captures twice.
        var index = stateValue.indexOf(captureId);
        if (index > -1) {
            return;
        }
        this.state.setFieldValue(this.field.id, tslib_1.__spreadArray(tslib_1.__spreadArray([], stateValue, true), [captureId], false));
    };
    ModelMutatorImage.prototype.copy = function (from) {
        for (var _i = 0, _a = from.getCaptures(); _i < _a.length; _i++) {
            var capture = _a[_i];
            this.add(capture.objectId);
        }
        return true;
    };
    return ModelMutatorImage;
}(collection_field_1.ModelMutator));
exports.ModelMutatorImage = ModelMutatorImage;
var CollectionModelFieldImage = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldImage, _super);
    function CollectionModelFieldImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldImage.isImageField = function (f) {
        return f.schema.type === CollectionModelFieldImage.TYPE;
    };
    Object.defineProperty(CollectionModelFieldImage.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorImage(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldImage.prototype, "value", {
        get: function () {
            return this.getCaptures();
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldImage.prototype.getOwnedCaptureIds = function () {
        return this.getCaptureIds();
    };
    CollectionModelFieldImage.prototype.getCaptureIds = function () {
        var stateValue = this.stateValue;
        if (stateValue == null) {
            return [];
        }
        return stateValue;
    };
    CollectionModelFieldImage.prototype.getOwnedCaptures = function () {
        return this.getCaptures();
    };
    CollectionModelFieldImage.prototype.getCaptures = function () {
        var _this = this;
        return this.getCaptureIds().map(function (c) { return _this.collection.state.getCapture(c); }).filter(function (c) { return !!c; });
    };
    CollectionModelFieldImage.prototype.hasValue = function () {
        return this.value.length > 0;
    };
    CollectionModelFieldImage.TYPE = core_api_1.IkeFieldType.IMAGE;
    return CollectionModelFieldImage;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldImage = CollectionModelFieldImage;
//# sourceMappingURL=image.field.js.map